import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { coachSportsApi, sportsApi } from "@/lib/api";

/**
 * Master olahraga (ikon + cover). Jarang berubah, jadi di-cache lebih lama
 * supaya membuka menu Sport tidak selalu memukul API.
 */
export function useSports() {
    return useQuery({
        queryKey: ["sports"],
        queryFn: ({ signal }) => sportsApi.list(signal),
        staleTime: 5 * 60 * 1000,
    });
}

export function useCoachSports() {
    return useQuery({
        queryKey: ["coach-sports"],
        queryFn: ({ signal }) => coachSportsApi.list(signal),
    });
}

function useInvalidateSports() {
    const queryClient = useQueryClient();
    return () => {
        void queryClient.invalidateQueries({ queryKey: ["coach-sports"] });
        // Profil ikut memuat daftar olahraga, jadi dibersihkan juga.
        void queryClient.invalidateQueries({ queryKey: ["coach-profile"] });
    };
}

export function useAddCoachSport() {
    const invalidate = useInvalidateSports();

    return useMutation({
        mutationFn: ({ sportId, isPrimary }: { sportId: string; isPrimary?: boolean }) =>
            coachSportsApi.create(sportId, isPrimary),
        onSuccess: invalidate,
    });
}

export function useSetPrimaryCoachSport() {
    const invalidate = useInvalidateSports();

    return useMutation({
        mutationFn: ({ id, isPrimary }: { id: string; isPrimary: boolean }) =>
            coachSportsApi.setPrimary(id, isPrimary),
        onSuccess: invalidate,
    });
}

export function useRemoveCoachSport() {
    const invalidate = useInvalidateSports();

    return useMutation({
        mutationFn: (id: string) => coachSportsApi.remove(id),
        onSuccess: invalidate,
    });
}
